export const API_VERSION = "v1.0";
export const SOCKET_URL = "ws://localhost:5000/messages";
export const COM_PORT = "COM_PORT";
export const IP_ADDRESS = "IP_ADDRESS";
export const PORT = "PORT";

export const ARENA_TOKEN = ``;
export const SUPER_ADMIN_TOKEN = ``;
export const IMACULIX_TOKEN = ``;
export const PLATINUMCINEMAS_TOKEN = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjFiZjI1ZWM1LTIwNWEtNGM5Zi1iNmYyLWU0MTVjMDU4Mzg4MSIsImlhdCI6MTc0NTM5MDk1Nn0.A-DXSSvG1jtYHg-qHsgCtx9_oJH1feN3yF5cfIqQKrI`;
export const TOKEN = PLATINUMCINEMAS_TOKEN;


const HOST_URL = `platinumcinemas-kiosk.nuviotech.co`;

const LIVEBASEURL = `https://platinumcinemas-nuviotech.co`;
const DEVBASEURL = ``;
// const DEVBASEURL = `https://cinematic-server-gdc-3.brij.tech`;
// const DEVBASEURL = `http://shringar.brij.tech:3950`;

export const BASEURL =
  window.location.host === HOST_URL ? LIVEBASEURL : DEVBASEURL;

//  mode should be an integer
// 1- only ticket
// 2- only fnb
// 3 - both

export const mode = 3;
